module.exports = __webpack_public_path__ + "5b7fb04c4efd72b8524e9fa41acdfda6.svg";